import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const MapPin_1: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			y: 0,
		},
		config: {
			duration: 300,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [
						{
							y: -100,
						},
						{
							y: 50,
						},
						{
							y: -50,
						},
						{
							y: 0,
						},
					],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<span>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<animated.path // ???
					d="M207 51.63a90.45 90.45 0 00-75.86 139.71c7.46 12.53 19.22 29.83 31.28 46.92l1.88 2.74c6.87 9.7 13.77 19.26 20 27.75 13 17.82 22.89 30.95 22.89 30.95s9.9-13.15 22.91-31c6.2-8.49 13.09-18.05 20-27.75l1.86-2.63c18.64-26.44 36.57-53.35 39-62.38v-.23A90.48 90.48 0 00207 51.63zm30.54 104.17l-.09.12a2.14 2.14 0 00-.25.26c-.33.34-.87.93-1.58 1.74-7 7.88-30.51 36.86-27.26 66.18 0 0-18.55-16.23-29.44-40.58a90.89 90.89 0 01-5.85-17.46 2.68 2.68 0 01-.07-.27l-.27-1.32c-4.25-19.39-.07-34.36 4.81-44.14l.22-.43v-.07c.14-.32.27-.63.42-1a24.88 24.88 0 011.33-2.69c0-.06.06-.12.1-.18l.07.11c-.3.59-.65 1.28-1 2 .6-1.1 1.2-2.1 1.79-3l-.28-.09c.23-.39.48-.79.74-1.19a.12.12 0 010-.07c.44-.67.9-1.33 1.4-2 .73-1 1.53-1.92 2.36-2.82.59-.63 1.19-1.22 1.82-1.78l.1-.1h.05a35.19 35.19 0 0131.6-8.35c-.48.86-20.41 37.13-18 71.75 0 0 1-32.1 26.47-68.66a35.28 35.28 0 0110.77 54z"
					style={style}
				/>
				<path // ???
					d="M285.67 247l-9.22 21c26.27 6.38 43.15 16.29 43.15 27.42 0 19.24-50.43 34.84-112.63 34.84S94.33 314.63 94.33 295.39c0-10.79 15.86-20.43 40.76-26.83l-9.31-21.21c-58.31 9.16-98.27 27.9-98.27 49.52 0 30.65 80.35 55.51 179.46 55.51s179.45-24.86 179.45-55.51c0-21.93-41.08-40.87-100.75-49.87z"
				/>
			</svg>
		</span>
	)
}

export { MapPin_1 }
